import { TenantApp } from 'application/Shared/types/tenantApp';

/**
 * Sort applications by user count (lowest to highest)
 * @param data - The applications data to sort
 * @returns The sorted applications data
 */
export function sortByUserCount({ data }: { data: TenantApp[] }) {
    if (!Array.isArray(data)) {
        return data;
    }

    return data.sort((a, b) => {
        // Sort by userCount (ascending - lowest first)
        const userCountA = a.userCount || 0;
        const userCountB = b.userCount || 0;

        return userCountA - userCountB;
    });
}
